import form from './form';
import roleIndex from './index';
import { Router } from '@/legacy/Router';

Router.get('role', roleIndex);
Router.get('role/:any', form);
